import { render } from "./MenuWeek.vue?vue&type=template&id=25751944"
import script from "./MenuWeek.vue?vue&type=script&lang=js"
export * from "./MenuWeek.vue?vue&type=script&lang=js"

import "./MenuWeek.vue?vue&type=style&index=0&id=25751944&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__